// Are the prototype.js Ajax Responder functions available.
export function prototypeJSAjaxRespondersDefined() {
    return (
        typeof Ajax === 'object' &&
        typeof Ajax.Responders === 'object' &&
        typeof Ajax.Responders.register === 'function'
    );
};
